import {Component, Input, OnInit} from "@angular/core";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../store';
import {DialogComponent} from "../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {AddTagDialogComponent} from "../add-tag-dialog/add-tag-dialog.component";
import {WebsiteService} from "../../website.service";
import {DbResponse} from "../../../shared/interceptors/db-response";
import {WebsiteTag} from "../../website/website-tag";
import {filter, first} from "rxjs/operators";

export interface ITagsDialogData {
  domainIds?: any;
  addedTag?: any;
  removedTagId?: number;
  tagsList?: any;
}

@Component({
    selector: 'db-tags-list-dialog',
    templateUrl: 'tags-list-dialog.component.html',
    styleUrls: ['tags-list-dialog.component.scss'],
    standalone: false
})
export class TagsListDialogComponent extends DialogComponent<ITagsDialogData, boolean> implements OnInit {
  public loading: boolean;
  public data: any = [];
  public addTagData: any = [];
  public isMobile: boolean;
  @Input() domainIds?: any;
  @Input() addedTag?: any;
  @Input() removedTagId?: number;
  @Input() tagsList?: any;

  constructor(
    private _dialogService: DialogService,
    private _websiteService: WebsiteService,
    private _store: Store<fromStore.DbStoreState>
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 991;
    this.getData();
  }

  public getData(): void {
    this._store.select(fromStore.getWebsiteTags()).subscribe((tags: any) => {
      if (tags) {
        this.tagsList = this.removedTagId ? this.filterTagsList(tags) : tags;
      }
    });
  }

  public filterTagsList(tags): any {
    return tags.filter((websiteTag: WebsiteTag) => this.removedTagId && this.removedTagId !== websiteTag.id);
  }

  public onItemToggled([tag, checked]): void {
    this.domainIds.forEach((item) => {
      if (checked && tag.domains.includes(item)) {
        this.data.push({
          'domain_id': item,
          'tags': [tag.title],
        });
      }
      else {
        if (this.data.length) {
          for (let key in this.data) {
            if (this.data[key].tags.includes(tag.title)) {
              this.data[key].tags.splice([key], 1)
            }
          }
        }
        else if (this.domainIds.length === 1 && !checked){
          this.data.push({
            'domain_id': item,
            'tags': [],
          });
        }
      }
    });
  }

  public generateData(): void {
    /* merging and grouping objects with the same domain_id in this.data array */
    const arrayHashmap = this.data.reduce((obj, item) => {
      obj[item.domain_id] ? obj[item.domain_id].tags.push(...item.tags) : (obj[item.domain_id] = { ...item });
      return obj;
    }, {});

    this.addTagData = Object.values(arrayHashmap);
  }

  public addDomainTag(): void {
    this.tagsList && this.tagsList.forEach((tag: WebsiteTag): void => {
      if (tag.allDomainsHas || tag.someDomainsHas.length) {
        this.onItemToggled([tag, true]);
      }
    });
    this.generateData();

    this._websiteService.addDomainTag(this.addTagData)
      .pipe(filter((response: DbResponse): boolean => !!response),
        first())
      .subscribe((response: DbResponse): void => {
        this.result = true;
        this.close();
        if (response.success) {
          this._store.dispatch( new fromStore.LoadWebsites() );
          this._store.dispatch( new fromStore.LoadWebsiteTags() );
          this.getData();
        }
      });
  }

  public showAddTagDialog() {
    this.close();
    this._dialogService.addDialog(AddTagDialogComponent, {
      domainIds: this.domainIds
    });
  }
}
